/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Skill_Groups_EmailInputs */

const en_tables_skill_groups_email = /** @type {(inputs: Tables_Skill_Groups_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups Email`)
};

const de_tables_skill_groups_email = /** @type {(inputs: Tables_Skill_Groups_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

/**
* | output |
* | --- |
* | "Groups Email" |
*
* @param {Tables_Skill_Groups_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_skill_groups_email = /** @type {((inputs?: Tables_Skill_Groups_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Skill_Groups_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_skill_groups_email(inputs)
	return de_tables_skill_groups_email(inputs)
});